export const CustomSwitch = ({ checked, onChange, id, label }) => {
    return (
      <div className="custom-switch p-0">
      <label htmlFor={id} className="custom-switch-label mb-0 mr-2">{label}</label>
      <label className="custom-switch-wrapper mb-0">
        <input
          type="checkbox"
          id={id}
          checked={checked}
          onChange={onChange}
          className="custom-switch-input"
        />
        <span className="custom-switch-slider"></span>
      </label>
    </div>
    );
  };